export default __webpack_public_path__ + "files/0b8d56c39baf992e5e4c58d74fde0fd6.png";